<template>
  <div>
    <div class="text-muted small">{{activity.created_at | formatRelativeDate}}</div>
    <!--USER LINK-->

    <UserLink :user="activity.causer" v-if="activity.causer"/>

    <span v-if="!activity.causer">{{ $t('system.system') }}</span>

    <!--ACTIVITY LOG ACTION-->
    <span>
      {{ $t('actions.' + $options.filters.slugify(activity.description)) }}
    </span>

    <!--ADDED-->
    <div v-if="activity.description === 'added'">
        <span v-if="activity.properties.model_type == 'App\\Process\\Models\\Process'">
            {{ $t('projects.process.label') | lowerCase }}
        </span>
        <span v-if="activity.properties.model_type == 'App\\Activity\\Models\\Activity'">
            {{ $t('projects.activity.label') | lowerCase }}
        </span>
        <span v-if="activity.properties.model_type == 'App\\System\\Models\\System'">
            {{ $t('projects.system.label') | lowerCase }}
        </span>
        <span v-if="activity.properties.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
            {{ $t('projects.third_party.label')  | lowerCase}}
        </span>

        <span> {{ $t('system.scope') | lowerCase}}</span>
        <span>
          {{activity.properties.model.name}}
        </span>
    </div>

    <!--DELETED-->
    <div v-if="activity.description === 'removed'">

        <span v-if="activity.properties.model_type == 'App\\Process\\Models\\Process'">
            {{ $t('projects.process.label') | lowerCase }}
        </span>
        <span v-if="activity.properties.model_type == 'App\\Activity\\Models\\Activity'">
            {{ $t('projects.activity.label') | lowerCase }}
        </span>
        <span v-if="activity.properties.model_type == 'App\\System\\Models\\System'">
            {{ $t('projects.system.label') | lowerCase }}
        </span>
        <span v-if="activity.properties.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
            {{ $t('projects.third_party.label')  | lowerCase}}
        </span>

        <span> {{ $t('system.scope') | lowerCase}}</span>

        <span>
          {{activity.properties.model.name}}
        </span>
    </div>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';

  export default {
    name: 'Project',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0
      }
    },
    props: {
      activity: {},
      changes: false
    },
    components: {
      UserLink
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
      loadContent(page) {
      },
      isObject: function (object) {
        return typeof object == "object"
      },
      makeTitle(slug) {
        var words = slug.split('_');

        for (var i = 0; i < words.length; i++) {
          if (words[i] !== 'id') {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
          } else {
            words[i] = '';
          }

        }

        return words.join(' ');
      }
    },
    created() {
    }
  }
</script>

<style scoped lang="scss">

</style>
